/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { LightInput, PrimaryButton, FieldWrapper } from 'ui';
import { FluidPreloader } from 'components/core/preloader';
import { Form, Field } from 'formik';
import TextArea from 'components/core/text-area';
import Icon from 'components/core/icon';

import FooterShared from './layout/footer';
import HeaderShared from './layout/header';
import s from './styles.module.scss';

const ContactUs = ({ className = null, children = null, isSubmitting, ...props }) => {
  props = {
    ...props,
    errors: typeof props.errors === 'undefined' ? null : props.errors,
  };

  const { t } = useTranslation();

  return (
    <div className={cx(s.sharedForm, className)}>
      <HeaderShared>
        <Icon className={s.sharedFormLogo} icon={Icon.icons.logo} />
      </HeaderShared>
      <Form>
        <Field
          id="name"
          name="name"
          placeholder={t('name')}
          component={FieldWrapper}
          inputComponent={LightInput}
          className={s.sharedFormField}
        />
        <Field
          id="email"
          name="email"
          placeholder={t('email')}
          component={FieldWrapper}
          inputComponent={LightInput}
          className={s.sharedFormField}
        />
        <Field
          id="message"
          name="message"
          placeholder={t('your_message')}
          component={TextArea}
          className={s.sharedFormTextField}
          wrapperClassName={s.sharedFormField}
          error={(props.errors && (props.errors.detail || props.errors.message || null)) || null}
          errorColor={s.errorColor}
        />
        <PrimaryButton
          type="submit"
          className={s.sharedFormSubmit}
          onClick={props.handleSubmit}
          isDisabled={isSubmitting}
        >
          {isSubmitting ? <FluidPreloader light /> : <>{t('send')}</>}
        </PrimaryButton>
      </Form>
      <FooterShared className="singleLink">
        <Link to="/sign-in" className={s.sharedFormFooterLink}>
          <Icon className={s.sharedFormFooterLinkIcon} icon={Icon.icons.arrowLeft} />
          <div className={s.sharedFormFooterLinkText}>{t('back')}</div>
        </Link>
      </FooterShared>
    </div>
  );
};

ContactUs.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  errors: PropTypes.shape(),
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default ContactUs;
